import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Themed replacement for the recharts default tooltip.
 * Values stay in text ink; the coloured dot carries series identity.
 */
export default function ChartTooltip({ active, payload, label, formatValue, labelFormatter }) {
  if (!active || !payload?.length) return null;

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        border: 1,
        borderColor: "border.default",
        borderRadius: 2,
        boxShadow: 6,
        px: 1.5,
        py: 1,
        minWidth: 120,
        pointerEvents: "none",
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        {labelFormatter ? labelFormatter(label, payload) : label}
      </Typography>
      {payload.map((entry) => (
        <Box
          key={entry.dataKey ?? entry.name}
          sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              flexShrink: 0,
              bgcolor: entry.color || entry.payload?.fill,
            }}
          />
          <Typography variant="body2" sx={{ fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
            {formatValue ? formatValue(entry.value, entry) : entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
